import { render, staticRenderFns } from "./PartnerPrimaryYN.vue?vue&type=template&id=3767556b"
import script from "./PartnerPrimaryYN.vue?vue&type=script&lang=js"
export * from "./PartnerPrimaryYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports